import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-file",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Vista previa del documento")
], -1 /* HOISTED */)
const _hoisted_2 = {
  key: 1,
  ref: "dvCanvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    position: "center",
    visible: _ctx.visibleModal,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleModal) = $event)),
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '75vw' },
    modal: true,
    maximizable: false,
    closable: true,
    closeOnEscape: true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Toolbar, null, {
        end: _withCtx(() => [
          _createCommentVNode("\r\n                <Button icon=\"pi pi-plus-circle\" v-tooltip=\"'Ampliar'\" class=\"p-button-rounded p-button-secondary mr-2\" @click=\"widthComponent = widthComponent-10\"/>\r\n                <Button icon=\"pi pi-minus-circle\" v-tooltip=\"'Alejar'\" class=\"p-button-rounded p-button-secondary mr-2\" @click=\"widthComponent = widthComponent+10\"/>\r\n                "),
          _withDirectives(_createVNode(_component_Button, {
            id: "imprimir",
            icon: "pi pi-print",
            class: "p-button p-component p-button-icon-only p-button-rounded p-button-outlined",
            onClick: _ctx.printFile
          }, null, 8 /* PROPS */, ["onClick"]), [
            [_directive_tooltip, 'Imprimir fichero']
          ]),
          _withDirectives(_createVNode(_component_Button, {
            id: "descargar",
            icon: "pi pi-download",
            class: "p-button p-component p-button-icon-only p-button-rounded p-button-outlined ml-2",
            onClick: _ctx.downloadFile
          }, null, 8 /* PROPS */, ["onClick"]), [
            [_directive_tooltip, 'Descargar fichero']
          ])
        ]),
        _: 1 /* STABLE */
      }),
      (_ctx.isPdf)
        ? (_openBlock(), _createBlock(_component_vue_pdf_embed, {
            key: 0,
            ref: "pdfembed",
            source: _ctx.getUrl(_ctx.document)
          }, null, 8 /* PROPS */, ["source"]))
        : (_ctx.isCanvas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, null, 512 /* NEED_PATCH */))
          : (_openBlock(), _createBlock(_component_Message, {
              key: 2,
              severity: "info"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Descargando fichero...")
              ]),
              _: 1 /* STABLE */
            }))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible"]))
}